import React from "react"

import {connect} from "react-redux"
import history from "~/history.js"
import ComponentWithData from "~/utils/ComponentWithData"
import ShelfApi from "~/utils/ShelfApi.js"
import {Article} from "~/utils/ShelfEntities"

import {Button, Field, SelectField} from "~/components/"

class ArticleStockUpView extends ComponentWithData {
  constructor(props) {
    super(props)

    this.state = {
      quantity: null,
      locations: [],
      selectedLocation: null,
      note: null
    }
  }

  getData() {
    // this.getLocations()
    return Article.find(this.props.match.params.article_barcode)
  }

  renderLoading() {
    return <p>{this.props.t("loading")}</p>
  }

  renderError() {
    return (
      <p>
        {this.props.t("error")} {this.state.error}
      </p>
    )
  }

  renderEmpty() {
    return <p>{this.props.t("articles.detail.notFound")}</p>
  }

  renderWithData() {
    const {barcode, product, stocks, is_singular_item} = this.state.data

    const getLocations = () =>
      stocks.filter(
        stock => stock.storage_place && stock.storage_place.type === "Location"
      )

    const onArticleStockUp = () => {
      if (
        window.confirm(
          this.props.t("articles.detail.stockUpConfirmation", {
            quantity: this.state.quantity || 1,
            productName: product.name,
            selectedLocation: this.state.selectedLocation
          })
        )
      ) {
        ShelfApi.post("/stock_ups", {
          stock_up: {
            article_barcode: barcode,
            location_barcode: this.state.selectedLocation,
            quantity: this.state.quantity || 1,
            note: this.state.note
          }
        })
          .then(res => history.push(`/article/${barcode}`))
          .catch(err =>
            alert(Object.values(err.response.data.errors).join(", "))
          )
      }
    }

    return (
      <div className="sh-detail-view">
        <div className="header">
          <div className="title">
            {this.props.t("articles.detail.stockUpTitle")}
          </div>
        </div>

        <div style={{maxWidth: 550, padding: 25}}>
          {!!!is_singular_item && (
            <Field
              label={this.props.t("articles.details.quantity")}
              type="text"
              name="quantity"
              value={this.state.quantity}
              onChange={e => {
                const parsedInput = e.target.value
                if (!isNaN(parsedInput) || "" || null) {
                  this.setState({quantity: parsedInput})
                }
              }}
            />
          )}

          <SelectField
            label={this.props.t("articles.detail.sourceLocation")}
            name="source_location"
            options={getLocations().map(location => ({
              id: location.storage_place.barcode,
              name: location.storage_place.name
            }))}
            onChange={option => {
              this.setState({
                selectedLocation: option
              })
            }}
          />

          <Field
            label={this.props.t("articles.detail.note")}
            type="textarea"
            name="note"
            value={this.state.note}
            onChange={e => this.setState({note: e.target.value})}
          />
          <div style={{display: "flex", justifyContent: "flex-end"}}>
            <Button
              style={{marginTop: 20, marginRight: 20}}
              secondary
              to={"/article/" + barcode}
              label={this.props.t("cancel")}
            />
            <Button
              style={{marginTop: 20}}
              disabled={!this.state.selectedLocation || !this.state.quantity}
              primary
              onClick={() => onArticleStockUp()}
              label={this.props.t("save")}
            />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({auth}) => {
  const {user} = auth
  const {settings} = user
  const {
    usingViscosity,
    usingTestDate,
    usingArticleDocuments,
    usingLotNumber
  } = settings
  return {usingViscosity, usingTestDate, usingArticleDocuments, usingLotNumber}
}

export default connect(mapStateToProps)(ArticleStockUpView)



// WEBPACK FOOTER //
// ./src/views/detail/ArticleStockUpView.js